import styled from 'styled-components';
import React from 'react';

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 8px 0 8px;
`;

const Tab = styled.div<{ $isSelected: boolean }>`
  flex: 1 1 100%;
  text-align: center;
  border-bottom: 1px solid ${props => (props.$isSelected ? '#3994DE' : '#CCCCCC')};
  padding-bottom: 8px;

  color: ${props => (props.$isSelected ? '#225A91' : '#666666')};

  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
`;

type Props = {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
};

const tabs = [
  {
    value: 'skipped',
    label: 'Skipped Questions'
  },
  { value: 'completed', label: 'Completed Questions' }
];

export const FinalReviewTabs: React.FC<Props> = ({ selectedTab, setSelectedTab }: Props) => {
  const [skippedTab, completedTab] = tabs;

  return (
    <Wrapper>
      <Tab
        onClick={() => {
          setSelectedTab(skippedTab.value);
        }}
        $isSelected={selectedTab === skippedTab.value}
      >
        {skippedTab.label}
      </Tab>
      <Tab
        onClick={() => {
          setSelectedTab(completedTab.value);
        }}
        $isSelected={selectedTab === completedTab.value}
      >
        {completedTab.label}
      </Tab>
    </Wrapper>
  );
};
